import gql from "graphql-tag";
import {Constants} from "../../Constants/Constant";

export const CLIENT_INVOICE_FRAGMENT = gql`
fragment clientInvoice on clientInvoices {
   id
   invoiceNumber
   statusId
   invoiceDate
   billingFreight
   isReturned
   orderCharges: Charges_aggregate(where: {pointType: {_eq: "${Constants.PointTypes.OrderCity}"}}) { aggregate { sum{amount} } nodes{query} }
   pickupCharges: Charges_aggregate(where: {pointType: {_eq: "${Constants.PointTypes.PickupCity}"}}) { aggregate { sum{amount} } nodes{query} }
   dropCharges: Charges_aggregate(where: {pointType: {_eq: "${Constants.PointTypes.DropCity}"}}) { aggregate { sum{amount} } nodes{query} }
   Order{
     id
     orderNumber
     pickupDate
     priority
     materials
     clientobject
     pickuppartyobject
     droppingpartyobject
     internalstatus
     internalStatus{id name viewPath}
     orderDetails{
        id
        lrObject
        pickupPoint
        dropPoint
        splOfferedFreight
        truckOrder{ id truck{id platNo} }
      }
   }
}`

export const SUBSCRIBE_CLIENT_INVOICES_BY_ORDER_DATE = gql`
subscription subscribeClientInvoices($startDate:timestamptz!, $endDate:timestamptz!, $search: String!, $lrName: jsonb!, $status: [uuid!], $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){
 clientInvoices(where: {_and: [{Order:{createdAt: {_gte: $startDate}}},{Order:{createdAt: {_lte: $endDate}}}, {statusId: {_in: $status}},
    {_or: [{invoiceNumber: {_ilike: $search}}, {Client: {name: {_ilike: $search}}},{Order: {orderNumber: {_ilike: $search}}}, {Order: {orderDetails: {lrObject: {_contains: $lrName}}}}  ]},
    {Order:{clientobject: {_contains: $clientCity}}}, {Order:{pickuppartyobject: {_contains: $pickupCity}}}, {Order:{droppingpartyobject: {_contains: $dropCity}}}, ]},
    order_by: {Order: {createdAt: desc}}) {
   ...clientInvoice
  }
}${CLIENT_INVOICE_FRAGMENT}`

export const SUBSCRIBE_CLIENT_INVOICES_BY_INVOICE_DATE = gql`
subscription subscribeClientInvoices($startDate:timestamptz!, $endDate:timestamptz!, $search: String!, $lrName: jsonb!, $status: [uuid!], $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){
 clientInvoices(where: {_and: [{invoiceDate: {_gte: $startDate}}, {invoiceDate: {_lte: $endDate}}, {statusId: {_in: $status}},
    {_or: [{invoiceNumber: {_ilike: $search}}, {Client: {name: {_ilike: $search}}},{Order: {orderNumber: {_ilike: $search}}}, {Order: {orderDetails: {lrObject: {_contains: $lrName}}}}  ]},
    {Order:{clientobject: {_contains: $clientCity}}}, {Order:{pickuppartyobject: {_contains: $pickupCity}}}, {Order:{droppingpartyobject: {_contains: $dropCity}}}, ]},
    order_by: {invoiceDate: desc}) {
   ...clientInvoice
 }
}${CLIENT_INVOICE_FRAGMENT}`
